import classNames from 'classnames';
import { memo } from 'react';

import { CategoriesButtonGroup } from './components/CategoriesButtonGroup';
import { CustomerStoryCard } from './components/CustomerStoryCard';
import type { CustomerStoriesCarouselProps } from './types';
import { Heading } from '../../atoms';
import './customer-stories-carousel.scss';
import { CarouselLoop } from '../../molecules/Carousel';

const CustomerStoriesCarouselNoMemo = ({
  className,
  title,
  subtitle,
  categories,
  customerStories,
  selectedCategoryId,
  onCategoryChange,
}: CustomerStoriesCarouselProps) => {
  return (
    <div className={classNames('payflow-ui-customer-stories-carousel', className)}>
      <Heading level="h3" className="payflow-ui-customer-stories-carousel__title">
        {title}
      </Heading>

      <Heading level="h6" className="payflow-ui-customer-stories-carousel__subtitle">
        {subtitle}
      </Heading>

      <CategoriesButtonGroup
        categories={categories}
        onCategoryChange={onCategoryChange}
        selectedCategoryId={selectedCategoryId}
      />

      <CarouselLoop
        slides={customerStories
          .filter((story) => selectedCategoryId === null || story.categoryId === selectedCategoryId)
          .map((story) => (
            <CustomerStoryCard key={story.id} story={story} />
          ))}
      />
    </div>
  );
};

CustomerStoriesCarouselNoMemo.displayName = 'CustomerStoriesCarousel';

export const CustomerStoriesCarousel = memo(CustomerStoriesCarouselNoMemo, (prevProps, nextProps) => {
  return (
    prevProps.className === nextProps.className &&
    prevProps.title === nextProps.title &&
    prevProps.subtitle === nextProps.subtitle &&
    prevProps.selectedCategoryId === nextProps.selectedCategoryId &&
    prevProps.customerStories.every((story, index) => story.id === nextProps.customerStories[index].id) &&
    prevProps.categories.every((category, index) => category.id === nextProps.categories[index].id)
  );
});
